var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalenderWithoutBackground(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_6646",
    "data-name": "Group 6646",
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.239,
    height: 17.239,
    viewBox: "0 0 17.239 17.239",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3837",
    "data-name": "Group 3837",
    transform: "translate(0.507 6.084)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1414",
    "data-name": "Rectangle 1414",
    width: 16.225,
    height: 1.014,
    fill: "#363636"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3838",
    "data-name": "Group 3838",
    transform: "translate(5.375 2.028)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1415",
    "data-name": "Rectangle 1415",
    width: 6.49,
    height: 1.014,
    fill: "#363636"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3839",
    "data-name": "Group 3839",
    transform: "translate(0 2.028)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46",
    "data-name": "Path 46",
    d: "M-66.329,573.961h-14.6a1.32,1.32,0,0,1-1.318-1.318V560.068a1.32,1.32,0,0,1,1.318-1.318h1.623v1.014h-1.623a.3.3,0,0,0-.3.3v12.574a.3.3,0,0,0,.3.3h14.6a.3.3,0,0,0,.3-.3V560.068a.3.3,0,0,0-.3-.3h-1.623V558.75h1.623a1.32,1.32,0,0,1,1.318,1.318v12.574A1.32,1.32,0,0,1-66.329,573.961Z",
    transform: "translate(82.25 -558.75)",
    fill: "#363636"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3840",
    "data-name": "Group 3840",
    transform: "translate(11.358)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_47",
    "data-name": "Path 47",
    d: "M-50.8,558.009H-54.25v-3.346a.914.914,0,0,1,.913-.913h1.623a.914.914,0,0,1,.913.913ZM-53.236,557h1.42v-2.231h-1.42Z",
    transform: "translate(54.25 -553.75)",
    fill: "#363636"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3841",
    "data-name": "Group 3841",
    transform: "translate(2.434)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_48",
    "data-name": "Path 48",
    d: "M-72.8,558.009H-76.25v-3.346a.914.914,0,0,1,.913-.913h1.623a.914.914,0,0,1,.913.913ZM-75.236,557h1.42v-2.231h-1.42Z",
    transform: "translate(76.25 -553.75)",
    fill: "#363636"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3842",
    "data-name": "Group 3842",
    transform: "translate(6.186 8.924)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1416",
    "data-name": "Rectangle 1416",
    width: 1.623,
    height: 1.014,
    fill: "#363636"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3843",
    "data-name": "Group 3843",
    transform: "translate(9.431 8.924)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1417",
    "data-name": "Rectangle 1417",
    width: 1.623,
    height: 1.014,
    fill: "#363636"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3844",
    "data-name": "Group 3844",
    transform: "translate(12.676 8.924)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1418",
    "data-name": "Rectangle 1418",
    width: 1.623,
    height: 1.014,
    fill: "#363636"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3845",
    "data-name": "Group 3845",
    transform: "translate(2.941 10.952)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1419",
    "data-name": "Rectangle 1419",
    width: 1.623,
    height: 1.014,
    fill: "#363636"
  }))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3846",
    "data-name": "Group 3846",
    transform: "translate(6.186 10.952)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1420",
    "data-name": "Rectangle 1420",
    width: 1.623,
    height: 1.014,
    fill: "#363636"
  }))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3847",
    "data-name": "Group 3847",
    transform: "translate(9.431 10.952)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1421",
    "data-name": "Rectangle 1421",
    width: 1.623,
    height: 1.014,
    fill: "#363636"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3848",
    "data-name": "Group 3848",
    transform: "translate(12.676 10.952)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1422",
    "data-name": "Rectangle 1422",
    width: 1.623,
    height: 1.014,
    fill: "#363636"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3849",
    "data-name": "Group 3849",
    transform: "translate(2.941 12.98)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1423",
    "data-name": "Rectangle 1423",
    width: 1.623,
    height: 1.014,
    fill: "#363636"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3850",
    "data-name": "Group 3850",
    transform: "translate(6.186 12.98)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1424",
    "data-name": "Rectangle 1424",
    width: 1.623,
    height: 1.014,
    fill: "#363636"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3851",
    "data-name": "Group 3851",
    transform: "translate(9.431 12.98)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1425",
    "data-name": "Rectangle 1425",
    width: 1.623,
    height: 1.014,
    fill: "#363636"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalenderWithoutBackground);
export default __webpack_public_path__ + "static/media/calender_without_background.efa5be331714273d8a79d694b33e26d3.svg";
export { ForwardRef as ReactComponent };